import Component from "../../AbstractComponent";

class Navigation extends Component {

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    const path = this.props.params.path ? this.props.params.path : "";
    return this.redirect(path.replace(/\|/g, "/"));
  }
}

export { Navigation };
